export default "__VITE_ASSET__D$W5txRS__"